import React from "react";
import { lang } from "../lang";

function TagControls({
  settings,
  updateSetting,
  deleteTag,
  onUpdateTasksWithDeletedTag,
}) {
  const handleAddTags = (e) => {
    if (e.key === "Enter" && e.target.value.trim()) {
      e.stopPropagation();
      const newTags = e.target.value
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag && !settings.tags.includes(tag));
      if (newTags.length > 0) {
        updateSetting("tags", [...settings.tags, ...newTags].sort());
      }
      e.target.value = "";
    }
  };

  const handleFilterTagToggle = (tag, e) => {
    e.stopPropagation();
    updateSetting(
      "selectedFilterTags",
      settings.selectedFilterTags.includes(tag)
        ? settings.selectedFilterTags.filter((t) => t !== tag)
        : [...settings.selectedFilterTags, tag]
    );
  };

  const handleDeleteTag = (tagToDelete, e) => {
    e.stopPropagation();
    if (
      window.confirm(
        `Are you sure you want to delete the tag "${tagToDelete}"? This will remove it from the global list and all tasks.`
      )
    ) {
      deleteTag(tagToDelete);
      onUpdateTasksWithDeletedTag(tagToDelete);
    }
  };

  const handleClearFilter = (e) => {
    e.stopPropagation();
    updateSetting("selectedFilterTags", []);
  };

  if (!settings.useTags) return null;

  return (
    <div className="tag-controls" onClick={(e) => e.stopPropagation()}>
      <input
        type="text"
        className="tag-input"
        placeholder={lang.tagControls.tagInputPlaceholder}
        onKeyDown={handleAddTags}
        onClick={(e) => e.stopPropagation()}
      />
      <div className="tag-filter-checkboxes">
        {(settings.tags || []).map((tag) => (
          <div key={tag} className="tag-filter-item">
            <label className="tag-checkbox-label">
              <input
                type="checkbox"
                checked={settings.selectedFilterTags.includes(tag)}
                onChange={(e) => handleFilterTagToggle(tag, e)}
                onClick={(e) => e.stopPropagation()}
              />
              {tag}
            </label>
            <button
              className="delete-tag-button"
              onClick={(e) => handleDeleteTag(tag, e)}
              title={`Delete tag "${tag}"`}
            >
              &times;
            </button>
          </div>
        ))}
      </div>
      {settings.selectedFilterTags &&
        settings.selectedFilterTags.length > 0 && (
          <button className="clear-filter" onClick={handleClearFilter}>
            {lang.tagControls.clearFilter}
          </button>
        )}
    </div>
  );
}

export default TagControls;
